import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EventServicesService } from "../services/event-services.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SocketService } from "../services/socket.service";
import { JobServicesService } from "../services/job-services.service";
import moment from 'moment';
import { environment } from "src/environments/environment";
import { GlobalServicesService } from "../services/global-services.service";
import { MessageService } from "primeng/api";
import { FormBuilderService } from "../services/form-builder.service";
import { firstValueFrom, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SharedServicesService } from "../services/shared-services.service";
import { CrispService } from "../services/crisp.service";

@Component({
    selector: 'app-candidate-panel',
    templateUrl: './candidate-panel.component.html',
    styleUrls: ['./candidate-panel.component.css'],
    providers: [MessageService],
    standalone: false
})

export class CandidatePanelComponent implements OnDestroy, OnInit {
    eventId: string = '';
    userId: string = '';
    schoolId: string = '';
    interviewId: string = '';
    jitsiAPI: any;
    hmsRoomUrl: SafeResourceUrl | null = null;
    currentProvider: string = '';
    interviewStarted: boolean = false;
    userEventData: any;
    userInterviewData: any;
    stageIdNo: any;
    isLoading: boolean = true;
    stageId: string = '';
    validationError: boolean = false;
    meetingEnded: boolean = false;
    loadIDE: boolean = false;
    scheduleDT: any;
    dateFormat: any;
    timeFormat: any;
    combinedFormat: any;
    currentStatus: string = "";
    candidateEmail: string = '';
    candidateMobile: string = '';
    candidateProfilePic: string = 'assets/default-avatar.svg';
    meetingStatus: any;
    reloadInterview: boolean = false;
    mailVerified: boolean = false;
    mobileVerified: boolean = false;
    showCrispBtn: boolean = false;
    private destroy$ = new Subject<void>();
    private serviceSubs: any[] = [];
    mediaAccess: boolean = true;
    mediaAccessError: boolean = false;
    mediaErrorMessage: string = '';
    interviewMeeting: any;
    verificationRequired: boolean = true;
    enableScreen: boolean = true;
    company_id: string = '';
    metadataLoaded: boolean = false;
    companyConfig: any = {};

    constructor(private eventServices: EventServicesService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private socketService: SocketService,
        private globalService: GlobalServicesService,
        private messageService: MessageService,
        private formBuilderServices: FormBuilderService,
        private sharedService: SharedServicesService,
        private sanitizer: DomSanitizer,
        private crispService: CrispService
    ) { }

    @HostListener('window:beforeunload', ['$event'])
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.crispService.hideChat();
        if (this.currentStatus == 'Lobby') {
            this.updateInterviewStatus("INVITED")
        }
    };

    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHandler(event: any) {
        this.reloadInterview = true;
        localStorage.setItem('meetingStatus', this.meetingStatus);
        return true;
    }

    ngOnInit(): void {
        this.combinedFormat = 'DD-MM-YYYY hh:mm A';

        this.setupMetadataSubscription();

        this.activatedRoute.queryParamMap.subscribe(params => {
            this.eventId = params.get('eventId') || '';
            this.userId = params.get('userId') || '';
            this.schoolId = params.get('schoolId') || '';
            this.stageId = params.get('stageId') || '';
            this.interviewId = params.get('interviewId') || '';

            const isCompleted = params.get('completed') === 'true';
            if (isCompleted) {
                this.meetingEnded = true;
                const storedCandidateName = sessionStorage.getItem('candidatePanelCandidateName') || '';
                if (storedCandidateName) {
                    this.userInterviewData = { candidate_name: storedCandidateName } as any;
                }
            }

            this.isLoading = false;
            this.enableScreen = false;
        });

        localStorage.setItem('initialInterviewUrl', window.location.href);
    }

    private setupMetadataSubscription(): void {
        this.sharedService.initiateMetadataRequest(() => this.globalService.metadataFastApi())
            .subscribe({ error: () => {} });

        this.sharedService.metadata$.subscribe((companyDetails) => {
            if (companyDetails) {
                this.companyConfig = companyDetails.company_config || {};
                this.company_id = companyDetails.company_id || '';
                this.metadataLoaded = true;

                if (companyDetails.uuid) {
                    localStorage.setItem("companyUUID", companyDetails.uuid);
                }

                localStorage.setItem("CompanyDetails", JSON.stringify(companyDetails));

                this.proceedWithCandidateValidation();
            }
        });

        this.sharedService.metadataLoading$.subscribe((loading) => {
            if (!loading) {
                if (!this.sharedService.isMetadataLoaded()) {
                    let CompanyDetails: any = localStorage.getItem("CompanyDetails") ? JSON.parse(localStorage.getItem("CompanyDetails") || '{}') : {};
                    if (Object.keys(CompanyDetails).length > 0) {
                        this.companyConfig = CompanyDetails?.company_config || {};
                        this.company_id = CompanyDetails?.company_id || '';
                        this.metadataLoaded = true;

                        this.proceedWithCandidateValidation();
                    } else {
                        this.sharedService.initiateMetadataRequest(() => this.globalService.metadataFastApi())
                            .subscribe({ error: () => { } });
                    }
                }
            }
        });

        this.sharedService.metadataError$.subscribe((error) => {
            if (error) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error
                });
                this.metadataLoaded = true;

                this.proceedWithCandidateValidation();
            }
        });
    }

    private proceedWithCandidateValidation(): void {

        if (this.eventId && this.userId) {
            this.formBuilderServices.validateCandidateFastApi(this.eventId, this.userId, null).subscribe((response: any) => {
                if (response.status == 200) {
                    this.candidateEmail = response.body.candidate_email;
                }
            });
        }
    }

    checkAndInitiate(type: string, value: any) {
        if (type === 'mail') {
            this.mailVerified = value;
        } else if (type === 'details') {
            this.userInterviewData = value;
        }

        if (this.mailVerified && this.userInterviewData) {
            if (this.userInterviewData.hms_auth_token) {
                this.navigateToAiInterview();
            } else {
                if (this.companyConfig?.crisp_chat) {
                    this.initCrispAfterOtp();
                }
                this.initiateFunction();
            }
        }
    }

    private initCrispAfterOtp(): void {
        if (this.showCrispBtn || !this.crispService.isEnabled) return;
        this.showCrispBtn = true;
        this.crispService.chatOpened$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.showCrispBtn = false;
        });
        this.crispService.chatClosed$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.showCrispBtn = true;
        });
    }

    openCrispChat(): void {
        this.crispService.openChat();
    }

    private navigateToAiInterview(): void {
        this.isLoading = true;
        const sessionData = {
            sessionId: this.userInterviewData.session_id,
            agentId: this.userInterviewData.agent_uuid || null,
            authToken: this.userInterviewData.hms_auth_token,
            roomId: this.userInterviewData.hms_room_id,
            wsAuthToken: this.userInterviewData.ws_auth_token,
        };

        const interviewDetails = {
            interview: {
                room_name: this.userInterviewData.room_name,
                status: this.userInterviewData.interview_status,
                scheduled_at: this.userInterviewData.interview_start_at,
                interview_start_at: this.userInterviewData.interview_start_at,
                interview_end_at: this.userInterviewData.interview_end_at,
            },
            candidate: {
                first_name: this.userInterviewData.candidate_name?.split(' ')[0] || 'Candidate',
                last_name: this.userInterviewData.candidate_name?.split(' ').slice(1).join(' ') || '',
                email: this.userInterviewData.candidate_email || this.candidateEmail,
            },
            event: {
                id: this.eventId,
                stage_id: this.stageId,
            },
            // Store UUIDs for interview status updates
            candidate_uuid: this.userId,
            stage_uuid: this.stageId,
            interview_uuid: this.interviewId
        };

        const aiInterviewToken = this.userInterviewData.ws_auth_token || localStorage.getItem('token') || '';
        
        localStorage.setItem('aiInterviewToken', aiInterviewToken);
        localStorage.setItem('aiInterviewDetails', JSON.stringify(interviewDetails));
        localStorage.setItem('aiSessionData', JSON.stringify(sessionData));
        localStorage.setItem('aiInterviewCandidateUuid', this.userId);
        localStorage.setItem('aiInterviewStageUuid', this.stageId);
        localStorage.setItem('aiInterviewInterviewUuid', this.interviewId);
        localStorage.removeItem('aiInterviewStarted');

        sessionStorage.setItem('candidatePanelEventId', this.eventId);
        sessionStorage.setItem('candidatePanelUserId', this.userId);
        sessionStorage.setItem('candidatePanelStageId', this.stageId);
        sessionStorage.setItem('candidatePanelSchoolId', this.schoolId);
        
        // Store candidate name in sessionStorage for completed screen (temporary display)
        const candidateName = this.userInterviewData?.candidate_name || '';
        sessionStorage.setItem('candidatePanelCandidateName', candidateName);


        // Navigate to AI Interview room
        this.router.navigate(['/ai-interview/session']);
    }

    dateAndTimeFormatter(dateTime: string) {
        const dateObj = new Date(dateTime);
        const formattedDate = dateObj.toISOString().split('T')[0];
        const formattedTime = dateObj.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        return `${formattedDate} ${formattedTime} UTC`
    }

    async initiateFunction() {
        if (this.userId && this.eventId && this.schoolId && this.stageId && this.userInterviewData && this.company_id) {
            this.meetingStatus = this.userInterviewData.interview_status;
            if (this.userInterviewData.interview_status == "Completed") this.meetingEnded = true;
            if (this.userInterviewData.interview_status == 'In Meeting') {
                this.currentStatus = this.userInterviewData.interview_status;
                this.socketService.connect(this.interviewId, this.userId);
                //this.checkMediaAccess();
                this.initiateCall();
                // return;
            } else {
                if (!this.meetingEnded) {
                    const interviewStartTime = this.dateAndTimeFormatter(this.userInterviewData.interview_start_at)
                    this.scheduleDT = moment(new Date(interviewStartTime)).format(this.combinedFormat)
                    let updateStatus = await this.updateInterviewStatus('LOBBY');
                    if (updateStatus) {
                        this.currentStatus = 'Lobby';
                        this.socketService.connect(this.interviewId, this.userId);
                    } else {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong. Please contact Administrator' });
                        this.validationError = true;
                    }
                    this.isLoading = false;
                    this.socketService.connect(this.interviewId, this.userId);
                    this.socketHandler();
                }
            }
            this.isLoading = false;
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong. Please contact Administrator' });
            this.isLoading = false;
        }


    }


    private socketHandler() {
        const sub = this.socketService.messageReceived.subscribe((message: any) => {
            if (message && message.action) {
                switch (message.action) {
                    case 'call_Initiated': {
                        this.initiateCall();
                        break;
                    }
                    case 'meetingEnd': {
                        this.interviewStarted = false;
                        this.meetingEnded = true;
                        break;
                    }
                }
            }
        });
        this.serviceSubs.push(sub);
    }

    public async initiateCall() {
        this.updateInterviewStatus("IN_MEETING");
        this.interviewStarted = true;
        const candidateName = this.userInterviewData.candidate_name && this.userInterviewData.candidate_name.trim() !== '' ? this.userInterviewData.candidate_name : 'Candidate';

        try {
            this.eventServices.getMeetingToken(
                candidateName,
                this.interviewId,
                true,
                this.candidateProfilePic
            ).subscribe(async (response: any) => {
                const tokenData = response.body;
                this.currentProvider = tokenData.provider || 'jitsi';

                if (this.currentProvider === 'hms') {
                    const roomCode = tokenData.room_code;
                    const subdomain = tokenData.hms_subdomain;
                    if (!roomCode || !subdomain) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to initialize the interview room.'
                        });
                        return;
                    }

                    const encodedName = encodeURIComponent(candidateName || 'Candidate');
                    let iframeUrl = `https://${subdomain}.app.100ms.live/meeting/${roomCode}?name=${encodedName}`;
                    this.hmsRoomUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);

                } else {
                    await this.globalService.loadScript('script', 'https://meet.jit.si/external_api.js', 'text/javascript', 'jitsi-external-api');

                    const jitsi_div: any = document.getElementById('jaas-container');

                    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                        this.mediaAccessError = true;
                        this.mediaErrorMessage = 'Camera/microphone access is not available. Please use a modern browser and allow permissions.';
                        return;
                    }

                    if (!this.jitsiAPI) {
                        try {
                            this.jitsiAPI = new (window as any).JitsiMeetExternalAPI("8x8.vc", {
                                roomName: tokenData.room_identifier,
                                parentNode: document.querySelector('#jaas-container'),
                                configOverwrite: {
                                    prejoinConfig: {
                                        enabled: false
                                    },
                                    apiLogLevels: ['error'],
                                    prejoinPageEnabled: false,
                                    startWithAudioMuted: false,
                                    startWithVideoMuted: false,
                                    hideParticipantsStats: true,
                                    hideConferenceTimer: true,
                                    disableTileView: true,
                                    startScreenSharing: false,
                                    fileRecordingsEnabled: false,
                                    liveStreamingEnabled: false,
                                    localRecording: { disable: true },
                                    hideRecordingLabel: true,
                                    toolbarButtons: ['desktop', 'raisehand', 'fullscreen', 'chat']
                                },
                                interfaceConfigOverwrite: {
                                    VIDEO_QUALITY_LABEL_DISABLED: true,
                                    FILM_STRIP_MAX_HEIGHT: 0
                                },
                                userInfo: {
                                    displayName: this.userInterviewData.candidate_name,
                                    email: this.userInterviewData.candidate_email
                                },
                                jwt: tokenData.jwt_token
                            });
                            this.jitsiAPI.addListener('videoConferenceJoined', async () => {
                                this.meetingStatus = 'IN_MEETING';
                                this.reloadInterview = false;
                                this.jitsiAPI.executeCommand('toggleShareScreen');
                                let roomInfo = await this.jitsiAPI.getRoomsInfo();
                                if (roomInfo?.rooms?.[0]?.participants?.length) {
                                    roomInfo.rooms[0].participants.forEach((element: any) => {
                                        if (element.displayName == this.userInterviewData.candidate_name && element.role == 'participant') {
                                            this.jitsiAPI.executeCommand('kickParticipant', element.id);
                                        }
                                    });
                                }
                            });

                            this.jitsiAPI.addListener('videoConferenceLeft', () => {
                                this.interviewStarted = false;
                                this.jitsiAPI.dispose();
                                this.jitsiAPI = undefined;
                                this.meetingEnded = true;
                                jitsi_div.style.display = 'none';
                            });

                            this.jitsiAPI.addListener('participantLeft', async () => {
                                let rooomInfo = await this.jitsiAPI.getRoomsInfo();
                                if (rooomInfo?.rooms?.[0]?.participants?.length == 1) {
                                    this.interviewStarted = false;
                                    this.jitsiAPI.dispose();
                                    this.jitsiAPI = undefined;
                                    this.meetingEnded = true;
                                    jitsi_div.style.display = 'none';
                                }
                            });
                        } catch (e) {
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Failed to initialize the interview room. Please check your browser and permissions.'
                            });
                        }
                    }
                }
            });
        } catch (error) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to initialize the interview room. Please check your internet connection.'
            });
        }
    }
    private async delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    public async updateInterviewStatus(status: string): Promise<boolean> {
        const payload = { status };

        try {
            const response = await firstValueFrom(
                this.eventServices.updateInterviewStatusFastApi(payload, this.userId, this.stageId, this.interviewId)
            );
            this.currentStatus = status;
            return true;

        } catch (error) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed during validation, Contact Admin team!'
            });
            return false;
        }
    }

    openIDE() {
        this.loadIDE = true;

        this.eventServices.getOpenIdeFastApi(this.userId, this.stageId).subscribe({
            next: (res) => {
                if (res.status == 200) {
                    this.loadIDE = false;
                    window.open(res.body.link, '_blank');
                } else {
                    this.loadIDE = false;
                    alert('Something went wrong. Please contact Administrator');
                }
            },
            error: (err) => {
                this.loadIDE = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong. Please contact Administrator' });
            }
        })
    }

    public makeSound() {
        let audio = new Audio('../../assets/audio/participant-joined-3.wav');
        audio.play();
    };

    checkMediaAccess() {
        navigator.mediaDevices.getUserMedia({
            audio: true,
            video: true
        })
            .then((resp: any) => {
                this.mediaAccess = true;
            })
            .catch((err: any) => {
                this.mediaAccess = false;
                if (confirm("Kindly enable microphone and camera access in your browser")) {
                    setTimeout(() => { this.checkMediaAccess(); }, 5000);
                } else {
                    setTimeout(() => { this.checkMediaAccess(); }, 5000);
                }
            })
    }

    retryMediaAccess() {
        this.mediaAccessError = false;
        this.mediaErrorMessage = '';
        this.initiateCall();
    }
}